import React, {Component} from 'react';

class NoMatch extends Component {
	render() {
		return (
			<div className="NoMatch">
				Ingen matchande route
			</div>
		)
	}
}
export default NoMatch;



// WEBPACK FOOTER //
// ./src/js/pages/NoMatch.js